// A folder picked on one screen (the empty vault's "Your Computer" tile) and
// reviewed on another (the import page). Files can't travel in a URL, so the
// latest pick stays here and the URL carries only its token. A reload forgets
// it, and the import page falls back to its source screen.

let latest: { token: string; files: File[]; from: string | null } | null = null;

// `from` names the folder the files were picked from, for the review's
// "from:" line; null for loose files (or when the files' own root says it).
export const keepPickedFolder = (files: File[], from: string | null = null) => {
  const token = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
  latest = { token, files, from };
  return token;
};

export const pickedFolder = (token: string | null) =>
  token && latest?.token === token ? latest.files : null;

export const pickedFolderName = (token: string | null) =>
  token && latest?.token === token ? latest.from : null;
